// @flow
import React from 'react';
import styled from 'styled-components';
import { TextBlock } from 'bench-internal-theme';

const ErrorStateLayout = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 100%;
  max-width: 650px;
  margin: auto;
  margin-top: 24px;

  ${TextBlock} {
    margin-top: 8px;
  }
`;

type ErrorStateProps = {
  description?: string;
  title: string;
};

const ErrorState = ({ description, title }: ErrorStateProps) => (
  <ErrorStateLayout>
    <TextBlock styleType="mediumBold">{title}</TextBlock>
    {description && <TextBlock>{description}</TextBlock>}
  </ErrorStateLayout>
);

export default ErrorState;
